import React from 'react';
import PageHeader from '../../components/PageHeader';

const UserDetailsHeader = () => (
  <PageHeader title="User Details" linkText="Return to users list" linkAddress="/" />
);

export default UserDetailsHeader;
